export const autoRegURLs = {
  status: '/reg-status'
};
